import { Routes } from "@angular/router";
import { MainComponent } from "./main/main.component";
import { AboutUsComponent } from "./about-us.component";
import { RewardsProgramComponent } from "../how-it-works/rewards-program/rewards-program.component";
import { ProduceProgramComponent } from "../how-it-works/produce-program/produce-program.component";
import { DonationsComponent } from "./donations/donations.component";
import { SupportComponent } from "./support/support.component";
import { PackagingComponent } from "./packaging/packaging.component";

export const aboutUsRoutes: Routes = [
    {
        path: 'about-us',
        title: 'About Us',
        component: AboutUsComponent,
        children: [
            {
                path: 'main',
                title: 'About us',
                component: MainComponent
            },
            {
                path: 'donations',
                title: 'Donations',
                component: DonationsComponent
            },
            {
                path: 'support',
                title: 'Support',
                component: SupportComponent
            },
            {
                path: 'packaging',
                title: 'Sustainable packaging',
                component: PackagingComponent
            },
        ]
    }
];